import { useNavigate, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import style from './BlogArticleItem.module.css';

const translitMap = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'h',
  ґ: 'g',
  д: 'd',
  е: 'e',
  є: 'ie',
  ж: 'zh',
  з: 'z',
  и: 'y',
  і: 'i',
  ї: 'i',
  й: 'i',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'shch',
  ь: '',
  ю: 'iu',
  я: 'ia',
  ё: 'e',
  э: 'e',
  ы: 'y',
};
const transliterate = (s = '') =>
  s.replace(/[А-Яа-яЁёЄєІіЇїҐґЭэЫы]/g, ch => {
    const low = ch.toLowerCase();
    const t = translitMap[low] ?? '';
    return ch === low ? t : t.charAt(0).toUpperCase() + t.slice(1);
  });

/** Безпечний  з  */
const safeSlugify = (s = '', fallback = 'post') => {
  const base = transliterate(s)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
  return base || fallback;
};


// EN: /blog/post/:slug/:id  | інші: /:lang/blog/post/:slug/:id
const buildArticlePath = (lang, slug, id) =>
  lang && lang !== 'en'
    ? `/${lang}/blog/post/${slug}/${id}`
    : `/blog/post/${slug}/${id}`;

const BlogArticleItem = ({ info }) => {
  const { lang = 'en' } = useParams();
  const navigate = useNavigate();

  // назва/опис поточної мови з фолбеком на en або перший доступний
  const title = useMemo(() => {
    const byLang = info.titles?.find(el => el.language === lang)?.title;
    if (byLang) return byLang;
    const en = info.titles?.find(el => el.language === 'en')?.title;
    return en || info.titles?.[0]?.title || '';
  }, [lang, info]);

  const desc = useMemo(() => {
    const byLang = info.metaDescriptions?.find(
      el => el.language === lang,
    )?.metaDescription;
    if (byLang) return byLang;
    const en = info.metaDescriptions?.find(
      el => el.language === 'en',
    )?.metaDescription;
    return en || info.metaDescriptions?.[0]?.metaDescription || '';
  }, [lang, info]);

  const img = info.imageUrl || '';
  const slug = useMemo(
    () => safeSlugify(title, `post-${String(info._id).slice(0, 6)}`),
    [title, info._id],
  );

  const to = buildArticlePath(lang, slug, info._id);

  return (
    <div className={style.gradientContainer}>
      <article className={style.projectItem}>
        <h1>{title}</h1>

        {img && (
          <div className={style.imgContainer}>
            <img src={img} alt={title} loading="lazy" />
          </div>
        )}

        {desc && (
          <div className={style.descriptionContainer}>
            <p>{desc}</p>
          </div>
        )}

        <button
          type="button"
          className={style.website}
          onClick={() => navigate(to)}
        >
          Read more
        </button>
      </article>
    </div>
  );
};

export default BlogArticleItem;
